import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminPageLayout from "../../../components/midpoint/admin/layout/AdminPageLayout";
import AdminPageHeader from "../../../components/midpoint/admin/layout/AdminPageHeader";
import { AdminAutomotiveNav } from "../automotive/AdminAutomotiveNav";
import { CITY_STATUS_LABELS } from "../../../constants/automapCityExpansionConstants";
import { fetchExpansionCities } from "../../../services/automapCityExpansionApi";
import { AdminExpansionNav } from "./AdminExpansionShared";

export default function AdminExpansionCitiesPage() {
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchExpansionCities()
      .then((payload) => setCities(payload.cities || []))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <AdminPageLayout>
      <AdminPageHeader eyebrow="AutoMapa · Expansión" title="Ciudades" description="Configuración de expansión por mercado." />
      <AdminAutomotiveNav active="expansion" />
      <AdminExpansionNav active="cities" />
      <main className="admin-console__main wrap">
        <div className="import-actions">
          <Link className="admin-btn admin-btn--primary" to="/admin/expansion/cities/new">Nueva ciudad</Link>
        </div>
        {loading ? <p className="dealer-state-box">Cargando…</p> : null}
        {error ? <p className="dealer-state-box">{error}</p> : null}
        {!loading ? (
          <div className="import-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Ciudad</th>
                  <th>Departamento</th>
                  <th>Estado</th>
                  <th>Prioridad</th>
                  <th>Launch</th>
                  <th />
                </tr>
              </thead>
              <tbody>
                {cities.map((city) => (
                  <tr key={city.citySlug}>
                    <td>{city.city}</td>
                    <td>{city.department}</td>
                    <td>{CITY_STATUS_LABELS[city.status] || city.status}</td>
                    <td>{city.priority}</td>
                    <td>{city.targetLaunchDate?.slice(0, 10) || "—"}</td>
                    <td><Link to={`/admin/expansion/cities/${city.citySlug}`}>Abrir</Link></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : null}
      </main>
    </AdminPageLayout>
  );
}
